module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('symbol', [_c('radialGradient', {
    attrs: {
      "id": "setstar-color-1"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "#e029c0",
      "stop-opacity": "1.0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "80%",
      "stop-color": "#e029c0",
      "stop-opacity": "0.7"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": "#e029c0",
      "stop-opacity": "0"
    }
  })], 1), _vm._v(" "), _c('radialGradient', {
    attrs: {
      "id": "setstar-color-2"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "#e02690",
      "stop-opacity": "1.0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "80%",
      "stop-color": "#e02690",
      "stop-opacity": "0.7"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": "#e02690",
      "stop-opacity": "0"
    }
  })], 1), _vm._v(" "), _c('radialGradient', {
    attrs: {
      "id": "setstar-color-3"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "#e02360",
      "stop-opacity": "1.0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "80%",
      "stop-color": "#e02360",
      "stop-opacity": "0.7"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": "#e02360",
      "stop-opacity": "0"
    }
  })], 1), _vm._v(" "), _c('radialGradient', {
    attrs: {
      "id": "setstar-color-4"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "#ec2430",
      "stop-opacity": "1.0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "80%",
      "stop-color": "#ec2430",
      "stop-opacity": "0.7"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": "#ec2430",
      "stop-opacity": "0"
    }
  })], 1), _vm._v(" "), _c('radialGradient', {
    attrs: {
      "id": "setstar-color-5"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "#f82500",
      "stop-opacity": "1.0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "80%",
      "stop-color": "#f82500",
      "stop-opacity": "0.7"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": "#f82500",
      "stop-opacity": "0"
    }
  })], 1), _vm._v(" "), _c('radialGradient', {
    attrs: {
      "id": "setstar-color-6"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "#f96300",
      "stop-opacity": "1.0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "80%",
      "stop-color": "#f96300",
      "stop-opacity": "0.7"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": "#f96300",
      "stop-opacity": "0"
    }
  })], 1), _vm._v(" "), _c('radialGradient', {
    attrs: {
      "id": "setstar-color-7"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "#faa000",
      "stop-opacity": "1.0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "80%",
      "stop-color": "#faa000",
      "stop-opacity": "0.7"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": "#faa000",
      "stop-opacity": "0"
    }
  })], 1), _vm._v(" "), _c('radialGradient', {
    attrs: {
      "id": "setstar-color-8"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "#fccf00",
      "stop-opacity": "1.0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "80%",
      "stop-color": "#fccf00",
      "stop-opacity": "0.7"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": "#fccf00",
      "stop-opacity": "0"
    }
  })], 1), _vm._v(" "), _c('radialGradient', {
    attrs: {
      "id": "setstar-color-9"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "#fdfe00",
      "stop-opacity": "1.0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "80%",
      "stop-color": "#fdfe00",
      "stop-opacity": "0.7"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": "#fdfe00",
      "stop-opacity": "0"
    }
  })], 1), _vm._v(" "), _c('radialGradient', {
    attrs: {
      "id": "setstar-color-10"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "#9efd00",
      "stop-opacity": "1.0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "80%",
      "stop-color": "#9efd00",
      "stop-opacity": "0.7"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": "#9efd00",
      "stop-opacity": "0"
    }
  })], 1), _vm._v(" "), _c('radialGradient', {
    attrs: {
      "id": "setstar-color-11"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "#3efb00",
      "stop-opacity": "1.0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "80%",
      "stop-color": "#3efb00",
      "stop-opacity": "0.7"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": "#3efb00",
      "stop-opacity": "0"
    }
  })], 1), _vm._v(" "), _c('radialGradient', {
    attrs: {
      "id": "setstar-color-12"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "#40fc50",
      "stop-opacity": "1.0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "80%",
      "stop-color": "#40fc50",
      "stop-opacity": "0.7"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": "#40fc50",
      "stop-opacity": "0"
    }
  })], 1), _vm._v(" "), _c('radialGradient', {
    attrs: {
      "id": "setstar-color-13"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "#41fc9f",
      "stop-opacity": "1.0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "80%",
      "stop-color": "#41fc9f",
      "stop-opacity": "0.7"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": "#41fc9f",
      "stop-opacity": "0"
    }
  })], 1), _vm._v(" "), _c('radialGradient', {
    attrs: {
      "id": "setstar-color-14"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "#44fdcf",
      "stop-opacity": "1.0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "80%",
      "stop-color": "#44fdcf",
      "stop-opacity": "0.7"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": "#44fdcf",
      "stop-opacity": "0"
    }
  })], 1), _vm._v(" "), _c('radialGradient', {
    attrs: {
      "id": "setstar-color-15"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "#46fdff",
      "stop-opacity": "1.0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "80%",
      "stop-color": "#46fdff",
      "stop-opacity": "0.7"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": "#46fdff",
      "stop-opacity": "0"
    }
  })], 1), _vm._v(" "), _c('radialGradient', {
    attrs: {
      "id": "setstar-color-16"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "#38c1ff",
      "stop-opacity": "1.0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "80%",
      "stop-color": "#38c1ff",
      "stop-opacity": "0.7"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": "#38c1ff",
      "stop-opacity": "0"
    }
  })], 1), _vm._v(" "), _c('radialGradient', {
    attrs: {
      "id": "setstar-color-17"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "#2a84ff",
      "stop-opacity": "1.0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "80%",
      "stop-color": "#2a84ff",
      "stop-opacity": "0.7"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": "#2a84ff",
      "stop-opacity": "0"
    }
  })], 1), _vm._v(" "), _c('radialGradient', {
    attrs: {
      "id": "setstar-color-18"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "#276bff",
      "stop-opacity": "1.0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "80%",
      "stop-color": "#276bff",
      "stop-opacity": "0.7"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": "#276bff",
      "stop-opacity": "0"
    }
  })], 1), _vm._v(" "), _c('radialGradient', {
    attrs: {
      "id": "setstar-color-19"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "#2352ff",
      "stop-opacity": "1.0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "80%",
      "stop-color": "#2352ff",
      "stop-opacity": "0.7"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": "#2352ff",
      "stop-opacity": "0"
    }
  })], 1), _vm._v(" "), _c('radialGradient', {
    attrs: {
      "id": "setstar-color-20"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "#2039ff",
      "stop-opacity": "1.0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "80%",
      "stop-color": "#2039ff",
      "stop-opacity": "0.7"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": "#2039ff",
      "stop-opacity": "0"
    }
  })], 1), _vm._v(" "), _c('radialGradient', {
    attrs: {
      "id": "setstar-color-21"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "#1c20ff",
      "stop-opacity": "1.0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "80%",
      "stop-color": "#1c20ff",
      "stop-opacity": "0.7"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": "#1c20ff",
      "stop-opacity": "0"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca38c606","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/decoration/visualization/setstar.vue
// module id = 647
// module chunks = 0